/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_None_HelpInputs */



/**
* | output |
* | --- |
* | "No loudness normalization will be applied." |
*
* @param {Audio_Description_Export_Loudness_None_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_none_help = /** @type {((inputs?: Audio_Description_Export_Loudness_None_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_None_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune normalisation de loudness ne sera appliquée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wird keine Lautheitsnormalisierung angewendet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non verrà applicata alcuna normalizzazione della loudness.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нормализация громкости применяться не будет.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se aplicará normalización de sonoridad.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不会应用响度标准化。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラウドネス正規化は適用されません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई लाउडनेस नॉर्मलाइज़ेशन लागू नहीं किया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não será aplicada normalização da intensidade sonora.")
	return /** @type {LocalizedString} */ ("No loudness normalization will be applied.")
});